import { Setting } from '@bz/request';
function formatOdds(decimal: number, target: Setting.Decimal = setting.decimal, opts: { dp?: number } = {}) {
  const dp = opts.dp ?? 2;
  const fix = (n: number, digits = dp) => {
    const s = n.toFixed(digits);
    // 规避 "-0.00"
    return Number(s) === 0 ? (0).toFixed(digits) : s;
  };

  // 1) 校验
  if (!Number.isFinite(decimal) || decimal < 1) {
    return '-'; // 或者 throw new Error('Invalid decimal odds')
  }
  const d = decimal;
  const r = d - 1;
  const nearZero = (x: number) => Math.abs(x) < 1e-9;

  switch (target) {
    case Setting.Decimal.european:
      return fix(d, 2);

    case Setting.Decimal.american: {
      if (nearZero(r)) return '-'; // d≈1 无定义
      if (d >= 2) {
        const v = Math.round((d - 1) * 100);
        return `+${v}`;
      } else {
        const v = -Math.round(100 / (d - 1)); // 负数
        return String(v);
      }
    }

    case Setting.Decimal.hongKong:
      return fix(r, 2);

    case Setting.Decimal.indonesian: {
      if (nearZero(r)) return '-';
      if (d >= 2) return `+${fix(r, dp)}`; // 正
      return fix(-1 / r, dp); // 负
    }

    case Setting.Decimal.malaysian: {
      if (nearZero(r)) return '-';
      if (d < 2) return `+${fix(r, dp)}`; // 正
      return fix(-1 / r, dp); // 负
    }

    case Setting.Decimal.fractional: {
      if (nearZero(r)) return '0/1'; // d≈1
      // 用“最佳近似 + 约分”
      const maxDen = 100;
      let bestN = 0,
        bestD = 1,
        bestErr = Number.POSITIVE_INFINITY;

      for (let den = 1; den <= maxDen; den++) {
        const num = Math.round(r * den);
        const err = Math.abs(r - num / den);
        // 优先误差小；误差相等时优先更小分母
        if (err + 1e-9 < bestErr || (Math.abs(err - bestErr) < 1e-9 && den < bestD)) {
          bestN = num;
          bestD = den;
          bestErr = err;
        }
      }
      // 约分
      const g = (a: number, b: number): number => (b ? g(b, a % b) : Math.abs(a));
      const gcd = g(Math.abs(bestN), bestD) || 1;
      return `${bestN / gcd}/${bestD / gcd}`;
    }

    default:
      return fix(d, 2);
  }
}

export const OddsFormat = (props: { value: number; children?: number }) => {
  return (
    <>
      {props.value
        ? formatOdds(props.value)
        : props.children
          ? formatOdds(props.children)
          : props.value || props.children}
    </>
  );
};
